<div class="signin-page">
  <!-- Arrière-plan animé -->
  <div class="animated-background">
    <div class="globe-container">
      <img src="assets/images/shape/shape-12.png" alt="Globe" class="globe rotating-globe" />
      <div class="globe-ring ring-1"></div>
      <div class="globe-ring ring-2"></div>
      <div class="globe-ring ring-3"></div>
    </div>

    <!-- Objets flottants -->
    <div class="floating-objects">
      <img src="assets/images/shape/shape-34.png" alt="Bitcoin" class="floating-object bitcoin" />
      <img src="assets/images/shape/shape-21.png" alt="Ethereum" class="floating-object ethereum" />
      <img src="assets/images/shape/shape-20.png" alt="Chart" class="floating-object chart" />
      <img src="assets/images/shape/shape-28.png" alt="Dollar" class="floating-object dollar" />
      <img src="assets/images/shape/shape-14.png" alt="Graph" class="floating-object graph" />
    </div>

    <!-- Particules -->
    <div class="light-particles">
      <div class="light-particle particle-1"></div>
      <div class="light-particle particle-2"></div>
      <div class="light-particle particle-3"></div>
      <div class="light-particle particle-4"></div>
      <div class="light-particle particle-5"></div>
      <div class="light-particle particle-6"></div>
    </div>
  </div>

  <div class="container signin-container">
    <div class="row align-items-center min-vh-100">

      <!-- Contenu gauche -->
      <div class="col-lg-6 d-none d-lg-block">
        <div class="promo-content fade-in slide-in-left">
          <h2 class="display-4 fw-bold mb-4">
            Bienvenue sur<br>
            <span class="text-primary-color gradient-text">SappTradingPro</span>
          </h2>
          <p class="lead mb-4">
            Connectez-vous pour accéder à vos formations, signaux de trading en temps réel et gérer votre portefeuille crypto et forex.
          </p>
        </div>
      </div>

      <!-- Carte login -->
      <div class="col-lg-5 col-md-7 col-sm-9 mx-auto">
        <div class="signin-card card-custom fade-in-up">

          <div class="signin-header text-center mb-4">
            <h1 class="mb-2">Se connecter</h1>
            <p class="text-secondary">Accédez à votre espace membre</p>
          </div>

          <!-- <div class="d-flex justify-content-center mb-3">
            <a routerLink="/" class="btn btn-outline-custom">
              Retour à l'accueil
            </a>
          </div> -->

          <!-- Message erreur -->
          <div class="alert alert-danger alert-dismissible fade show" *ngIf="loginError">
            <i class="fa-solid fa-triangle-exclamation me-2"></i>
            {{ loginError }}
            <button type="button" class="btn-close" (click)="loginError = ''"></button>
          </div>

          <form [formGroup]="signinForm" (ngSubmit)="onSubmit()">

            <!-- Email -->
            <div class="form-group mb-3">
              <label for="email" class="form-label">
                Email <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-envelope"></i>
                <input
                  type="email"
                  id="email"
                  class="form-control custom-input"
                  placeholder="contact@example.com"
                  formControlName="email"
                  [class.is-invalid]="isFieldInvalid('email')"
                />
                <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                  {{ getFieldError('email') }}
                </div>
              </div>
            </div>

            <!-- Mot de passe -->
            <div class="form-group mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label for="password" class="form-label mb-0">
                  Mot de passe <span class="text-danger">*</span>
                </label>
                <a (click)="navigateToForgotPassword()" class="text-primary-color forgot-link cursor-pointer">
                  Mot de passe oublié ?
                </a>
              </div>

              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-lock"></i>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  class="form-control custom-input"
                  placeholder="Entrez votre mot de passe"
                  formControlName="password"
                  [class.is-invalid]="isFieldInvalid('password')"
                />
                <button type="button" class="password-toggle" (click)="togglePasswordVisibility()" tabindex="-1">
                  <i class="fa-solid" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('password')">
                  {{ getFieldError('password') }}
                </div>
              </div>
            </div>

            <!-- Remember -->
            <div class="form-group mb-4">
              <div class="form-check custom-checkbox">
                <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="rememberMe" />
                <label class="form-check-label" for="rememberMe">
                  Se souvenir de moi
                </label>
              </div>
            </div>

            <!-- Bouton -->
            <button
              type="submit"
              class="btn btn-primary-custom w-100 mb-3"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Se connecter</span>
              <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Connexion en cours...
              </span>
            </button>

            <!-- Signup -->
            <div class="text-center mt-4">
              <p class="mb-0 text-secondary">
                Vous n'avez pas encore de compte ?
                <a (click)="navigateToSignup()" class="text-primary-color cursor-pointer fw-bold">
                  Créer un compte
                </a>
              </p>
            </div>

          </form>
        </div>

        <!-- Sécurité -->
        <div class="security-info text-center mt-2 fade-in">
          <p class="text-secondary small mb-2">
            <i class="fa-solid fa-shield-halved text-primary-color me-1"></i>
            Connexion sécurisée avec chiffrement SSL/TLS
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
